// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_7a0eb56"};